import React from 'react';

const ReviewerCard = ({ card }) => {
  return (
    <div className="min-w-80 p-6 bg-white border border-gray-200 rounded-lg shadow">
      <div className="flex justify-between items-center">
        <h5 className="mb-1 text-xl font-bold tracking-tight text-gray-900 font-header">
          {card.data.short_name} - {card.data.quiz_num}
        </h5>
        <p className="mb-2 font-normal text-gray-700 text-right">{card.data.acad_year}</p>
      </div>

      <p className="mb-3 font-normal text-gray-700 text-left">
        {card.data.full_name}
      </p>

      <div className="flex justify-center space-x-4">
        {card.data.links.reviewers !== '' && (
          <a
            href={card.data.links.reviewers}
            target="_blank"
            className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300"
          >
            Reviewers
          </a>
        )}

        {card.data.links.notes !== '' && (
          <a
            href={card.data.links.notes}
            target="_blank"
            className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300"
          >
            Notes
          </a>
        )}

        {card.data.links.formula !== '' && (
          <a
            href={card.data.links.formula}
            target="_blank"
            className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300"
          >
            Formulas
          </a>
        )}
      </div>
    </div>
  );
};

export default ReviewerCard; 